__turbopack_context__.v({
  "card": "Studies-module__kE8uUG__card",
  "cardBody": "Studies-module__kE8uUG__cardBody",
  "comingSoon": "Studies-module__kE8uUG__comingSoon" + " " + __turbopack_context__.i(168195)["smallButton"],
  "eyebrow": "Studies-module__kE8uUG__eyebrow" + " " + __turbopack_context__.i(168195)["eyebrow"],
  "grid": "Studies-module__kE8uUG__grid",
  "headingSubtitle": "Studies-module__kE8uUG__headingSubtitle" + " " + __turbopack_context__.i(168195)["subtitle"],
  "headingTitle": "Studies-module__kE8uUG__headingTitle" + " " + __turbopack_context__.i(168195)["title"],
  "headingWrap": "Studies-module__kE8uUG__headingWrap",
  "joinButton": "Studies-module__kE8uUG__joinButton" + " " + __turbopack_context__.i(168195)["smallButton"],
  "list": "Studies-module__kE8uUG__list",
  "rowText": "Studies-module__kE8uUG__rowText" + " " + __turbopack_context__.i(168195)["body"],
  "rowTitle": "Studies-module__kE8uUG__rowTitle" + " " + __turbopack_context__.i(168195)["listTitle"],
  "section": "Studies-module__kE8uUG__section",
  "textGroup": "Studies-module__kE8uUG__textGroup",
  "thumb": "Studies-module__kE8uUG__thumb",
  "thumbMuted": "Studies-module__kE8uUG__thumbMuted",
});
